import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { RootState } from '@store/store'

export const voiceUrl = 'voice/'

export interface VoiceModel extends DjangoModel {
  mvoiceId: string
  name: string
  isDefault: boolean
  isDialogueFirstPersonDefault: boolean
  isDialogueSecondPersonDefault: boolean
}

const {
  slice: VoiceSlice,
  thunks: VoiceThunks,
  adapter: VoiceAdapter,
  selectors,
} = createGenericSlice<VoiceModel>('voice', voiceUrl, {})

export const VoiceAdapterExport = VoiceAdapter

export const { selectById: selectVoiceById, selectAll: selectAllVoices } =
  VoiceAdapter.getSelectors<RootState>((state: RootState) => state.voice)

export const { fetchById: fetchVoiceById, fetchAll: fetchAllVoices } =
  VoiceThunks
export const {
  selectLoading: selectVoiceLoading,
  selectIsIdInProgress: selectIsVoiceIdInProgress,
  selectError: selectVoiceError,
  selectByIds: selectVoicesByIds,
} = selectors

export default VoiceSlice.reducer
